module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-ford.aa284ca8.png";